var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTrainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.732,
    height: 44.274,
    viewBox: "0 0 100.732 44.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17975",
    "data-name": "Group 17975",
    transform: "translate(-30 -19.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(83.229 25.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(0.272 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1092.285,1001.885l-.907-2.44c-2,0-3.994,0-5.986.01-.093,0-.23.132-.269.233-.281.72-.542,1.448-.816,2.192h-3.486l5.543-14.469h3.859l5.546,14.474Zm-3.992-11.38-2.242,6.234h4.484Z",
    transform: "translate(-1055.147 -987.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M894.614,994.052l2.625,1.275a6.366,6.366,0,0,1-3.979,3.26,7.711,7.711,0,0,1-7.605-1.887,6.883,6.883,0,0,1-2.1-4.967,7.466,7.466,0,0,1,1.371-4.785,7.238,7.238,0,0,1,4.659-2.868,7.725,7.725,0,0,1,3.856.165,6.607,6.607,0,0,1,3.808,3.2l-2.638,1.308A3.98,3.98,0,0,0,892.743,987a4.3,4.3,0,0,0-5.7,2.523,4.97,4.97,0,0,0,.79,5.1,4.1,4.1,0,0,0,6.655-.366C894.521,994.19,894.564,994.128,894.614,994.052Z",
    transform: "translate(-871.92 -983.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M720.328,987.542h10.155v2.667H723.4v3.129h6.923v2.69h-6.935v5.962h-3.057Q720.328,994.791,720.328,987.542Z",
    transform: "translate(-720.328 -987.283)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M6.486-13.119v1.3H4.339v6.753H2.723v-6.753H.576v-1.3ZM9.28-10.464a2.272,2.272,0,0,1,.814-.8,2.263,2.263,0,0,1,1.149-.289v1.7h-.427a1.637,1.637,0,0,0-1.149.358A1.65,1.65,0,0,0,9.28-8.248v3.186H7.664v-6.4H9.28Zm2.632,2.182A3.7,3.7,0,0,1,12.3-10a2.834,2.834,0,0,1,1.05-1.154,2.8,2.8,0,0,1,1.483-.4,2.606,2.606,0,0,1,1.252.289,2.541,2.541,0,0,1,.86.727v-.912h1.628v6.4H16.945V-6a2.4,2.4,0,0,1-.86.745,2.631,2.631,0,0,1-1.264.294,2.718,2.718,0,0,1-1.472-.416A2.908,2.908,0,0,1,12.3-6.545,3.763,3.763,0,0,1,11.912-8.282Zm5.033.023a2.073,2.073,0,0,0-.231-1.01,1.628,1.628,0,0,0-.623-.646,1.666,1.666,0,0,0-.843-.225,1.637,1.637,0,0,0-.831.219,1.652,1.652,0,0,0-.618.641,2.007,2.007,0,0,0-.237,1,2.073,2.073,0,0,0,.237,1.01,1.7,1.7,0,0,0,.623.664,1.584,1.584,0,0,0,.825.231,1.666,1.666,0,0,0,.843-.225,1.628,1.628,0,0,0,.623-.646A2.073,2.073,0,0,0,16.945-8.259Zm4.029-3.959a.985.985,0,0,1-.71-.271.9.9,0,0,1-.283-.675.9.9,0,0,1,.283-.675.985.985,0,0,1,.71-.271.985.985,0,0,1,.71.271.9.9,0,0,1,.283.675.9.9,0,0,1-.283.675A.985.985,0,0,1,20.974-12.219Zm.8.762v6.4H20.154v-6.4Zm5.137-.092a2.465,2.465,0,0,1,1.847.721,2.762,2.762,0,0,1,.7,2.014v3.752H27.842V-8.594a1.658,1.658,0,0,0-.381-1.172,1.349,1.349,0,0,0-1.039-.41,1.382,1.382,0,0,0-1.056.41,1.643,1.643,0,0,0-.387,1.172v3.532H23.363v-6.4h1.616v.8a2.233,2.233,0,0,1,.825-.652A2.553,2.553,0,0,1,26.907-11.549Zm4.906-.67a.985.985,0,0,1-.71-.271.9.9,0,0,1-.283-.675.9.9,0,0,1,.283-.675.985.985,0,0,1,.71-.271.985.985,0,0,1,.71.271.9.9,0,0,1,.283.675.9.9,0,0,1-.283.675A.985.985,0,0,1,31.813-12.219Zm.8.762v6.4H30.994v-6.4Zm5.137-.092a2.465,2.465,0,0,1,1.847.721,2.762,2.762,0,0,1,.7,2.014v3.752H38.682V-8.594A1.658,1.658,0,0,0,38.3-9.766a1.349,1.349,0,0,0-1.039-.41,1.382,1.382,0,0,0-1.056.41,1.643,1.643,0,0,0-.387,1.172v3.532H34.2v-6.4h1.616v.8a2.233,2.233,0,0,1,.825-.652A2.553,2.553,0,0,1,37.747-11.549Zm6.591-.012a2.684,2.684,0,0,1,1.258.283,2.317,2.317,0,0,1,.854.733v-.912h1.628v6.441a3.431,3.431,0,0,1-.358,1.587A2.657,2.657,0,0,1,46.647-2.32a3.432,3.432,0,0,1-1.732.41,3.7,3.7,0,0,1-2.234-.635,2.354,2.354,0,0,1-.987-1.732h1.6a1.2,1.2,0,0,0,.548.7,1.91,1.91,0,0,0,1.022.26,1.581,1.581,0,0,0,1.143-.421,1.692,1.692,0,0,0,.439-1.276v-.993a2.455,2.455,0,0,1-.86.75,2.566,2.566,0,0,1-1.252.3,2.747,2.747,0,0,1-1.478-.416A2.894,2.894,0,0,1,41.8-6.545a3.763,3.763,0,0,1-.387-1.737A3.7,3.7,0,0,1,41.8-10a2.834,2.834,0,0,1,1.05-1.154A2.8,2.8,0,0,1,44.338-11.561Zm2.112,3.3a2.073,2.073,0,0,0-.231-1.01,1.628,1.628,0,0,0-.623-.646,1.666,1.666,0,0,0-.843-.225,1.637,1.637,0,0,0-.831.219,1.652,1.652,0,0,0-.618.641,2.007,2.007,0,0,0-.237,1,2.073,2.073,0,0,0,.237,1.01,1.7,1.7,0,0,0,.623.664,1.584,1.584,0,0,0,.825.231A1.666,1.666,0,0,0,45.6-6.6a1.628,1.628,0,0,0,.623-.646A2.073,2.073,0,0,0,46.451-8.259Z",
    transform: "translate(-0.576 33.685)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(30 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-logo_1_",
    transform: "translate(0 0.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(14.228 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-491.324,573.408a36.975,36.975,0,0,0-5.334,4.534,38.67,38.67,0,0,0-4.5,5.371c-1.963,2.874-3.81,2.139-5.392-1.2a20.673,20.673,0,0,0-4.169-5.7,20.845,20.845,0,0,0-5.7-4.17c-3.332-1.585-4.078-3.432-1.213-5.4a39.7,39.7,0,0,0,5.386-4.486A36.4,36.4,0,0,0-507.733,557c1.962-2.876,4.135-2.456,5.877.682a25.307,25.307,0,0,0,4.307,5.561,25.344,25.344,0,0,0,5.57,4.3c3.14,1.74,3.529,3.9.655,5.864",
    transform: "translate(519.406 -555.066)",
    fill: "#afda19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(14.127 11.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-491.282,568.685a36.9,36.9,0,0,0-5.334,4.534,38.6,38.6,0,0,0-4.5,5.371c-1.963,2.873-3.81,2.138-5.392-1.2a20.686,20.686,0,0,0-4.169-5.7,20.837,20.837,0,0,0-5.7-4.169c-3.332-1.586-4.078-3.432-1.213-5.4a39.715,39.715,0,0,0,5.386-4.486,36.408,36.408,0,0,0,4.512-5.356c1.962-2.875,4.135-2.456,5.877.682a25.254,25.254,0,0,0,4.307,5.561,25.326,25.326,0,0,0,5.57,4.3c3.14,1.74,3.528,3.9.655,5.864",
    transform: "translate(519.364 -550.344)",
    fill: "#de097c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(2.127 6.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-456.53,602.274a31.138,31.138,0,0,0-4.49,3.816,32.578,32.578,0,0,0-3.788,4.522c-1.652,2.418-3.207,1.8-4.539-1.009a17.409,17.409,0,0,0-3.51-4.8,17.547,17.547,0,0,0-4.8-3.509c-2.8-1.335-3.433-2.889-1.021-4.548a33.385,33.385,0,0,0,4.534-3.776,30.6,30.6,0,0,0,3.8-4.509c1.652-2.42,3.481-2.067,4.947.575a21.307,21.307,0,0,0,3.626,4.681,21.328,21.328,0,0,0,4.689,3.621c2.643,1.464,2.97,3.281.551,4.936",
    transform: "translate(480.168 -586.834)",
    fill: "#449cc7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 22.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-415.9,637.511a23.337,23.337,0,0,0-3.367,2.863,24.329,24.329,0,0,0-2.841,3.389c-1.239,1.815-2.4,1.351-3.4-.756a13.066,13.066,0,0,0-2.632-3.6,13.161,13.161,0,0,0-3.6-2.631c-2.1-1-2.574-2.167-.766-3.41a25.035,25.035,0,0,0,3.4-2.832,22.929,22.929,0,0,0,2.848-3.381c1.239-1.815,2.61-1.549,3.71.431a15.953,15.953,0,0,0,2.719,3.51,15.965,15.965,0,0,0,3.516,2.715c1.981,1.1,2.227,2.461.413,3.7",
    transform: "translate(433.624 -625.935)",
    fill: "#e6681a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(14.518 26.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-416.393,641.7a22.26,22.26,0,0,0-3.214,2.732,23.32,23.32,0,0,0-2.712,3.236c-1.183,1.732-2.3,1.289-3.249-.722a12.456,12.456,0,0,0-2.512-3.436A12.565,12.565,0,0,0-431.513,641c-2.008-.956-2.458-2.068-.731-3.255a23.938,23.938,0,0,0,3.245-2.7,21.941,21.941,0,0,0,2.719-3.227c1.183-1.733,2.492-1.48,3.541.411a15.258,15.258,0,0,0,2.6,3.352,15.272,15.272,0,0,0,3.356,2.591c1.892,1.049,2.126,2.349.395,3.534",
    transform: "translate(433.314 -630.651)",
    fill: "#f3bf0a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(20.768 16.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-348.075,722.088c2.419-1.655,2.092-3.472-.551-4.936q-.654-.363-1.271-.776a38.965,38.965,0,0,1-2.654,2.891q-.258.255-.52.506a25.445,25.445,0,0,1,2.147,1.924c.474.474.935.967,1.376,1.481q.716-.568,1.473-1.089",
    transform: "translate(353.072 -716.376)",
    fill: "#131312"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(14.128 19.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-371.957,702.741a33.84,33.84,0,0,1,3.227-3.731,34.335,34.335,0,0,1,3.017-2.728c-.441-.514-.9-1.007-1.376-1.481a25.393,25.393,0,0,0-2.147-1.924,39.279,39.279,0,0,1-4.866,3.98c-2.865,1.97-2.119,3.817,1.213,5.4q.475.226.932.481",
    transform: "translate(375.877 -692.877)",
    fill: "#1f2354"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(14.229 10.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-365.61,710.412a38.925,38.925,0,0,0,2.654-2.892,22.826,22.826,0,0,1-3.418-2.844,23.59,23.59,0,0,1-2.5-2.906q-.985.782-2.025,1.5c-2.865,1.971-2.119,3.818,1.213,5.4a18.545,18.545,0,0,1,3.552,2.245l.52-.506",
    transform: "translate(372.67 -701.771)",
    fill: "#267836"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(19.327 26.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-388.415,670.533c1.731-1.185,1.5-2.485-.395-3.534a15.269,15.269,0,0,1-3.356-2.591,15.256,15.256,0,0,1-2.6-3.352c-1.049-1.891-2.359-2.144-3.541-.411a21.44,21.44,0,0,1-2.224,2.725,23.412,23.412,0,0,1,3.487,2.9,20.684,20.684,0,0,1,4.169,5.7,10.143,10.143,0,0,0,.927,1.61q.156-.161.315-.322a22.276,22.276,0,0,1,3.214-2.732",
    transform: "translate(400.527 -659.48)",
    fill: "#d81e25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(14.519 31.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-331.425,727.031c1.445-.988,1.583-2.055.578-3a23.411,23.411,0,0,1-2.713,2.192c-1.4.965-1.368,1.882-.227,2.7a21.375,21.375,0,0,1,2.362-1.893",
    transform: "translate(334.629 -724.029)",
    fill: "#e14c1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(8.024 22.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-361.906,703.905c1.275,2.69,2.755,3.372,4.33,1.3a16.024,16.024,0,0,1-3.484-2.7,15.963,15.963,0,0,1-2.718-3.51c-.908-1.636-2-2.1-3.053-1.192.494.414.965.85,1.415,1.3a17.415,17.415,0,0,1,3.51,4.8",
    transform: "translate(366.831 -697.346)",
    fill: "#213e1c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrainer);
export default __webpack_public_path__ + "static/media/logo-trainer.6df520e4fe3fbace5dc3f29202d52216.svg";
export { ForwardRef as ReactComponent };